import { createApp } from 'vue'
import FanLetterLikeButton from '../components/fan_letter_like_button'
import dataPropsParser from '../data_props_parser'

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.getElementsByClassName('vue-fan-letter-like-button')

  Array.prototype.forEach.call(elements, element => {
    const dataProps = dataPropsParser(element.dataset.props)
    const app = createApp(FanLetterLikeButton, dataProps)
    app.mount(`#${element.id}`)
  })
})
